import React from 'react';
import { ChevronDown, ChevronRight, ClipboardList } from 'lucide-react';
import { SALES_DEPARTMENT_TOOL_MENU_ITEMS } from './constants';

export default function SalesDepartmentToolsMenu({
  user,
  isOpen,
  setIsOpen,
  activeMenuItem,
  handleSelectTool,
  closeOtherMenus,
}) {
  if (!(user.permissions?.project_details_access || user.email === 'vinsimon23@gmail.com')) {
    return null;
  }

  return (
    <div>
      <button
        onClick={() => {
          const next = !isOpen;
          setIsOpen(next);
          if (next && closeOtherMenus) closeOtherMenus();
        }}
        className={`w-full flex items-center justify-between px-4 py-3 text-left transition-colors ${
          activeMenuItem === 'project-details' ? 'bg-indigo-100 text-indigo-900 font-semibold' : 'text-gray-700 dark:text-gray-100 hover:bg-indigo-50 dark:hover:bg-black'
        }`}
      >
        <span className="flex items-center">
          <ClipboardList className="mr-3 h-5 w-5" />
          Sales Department Tools
        </span>
        {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
      </button>
      {isOpen && (
        <div className="ml-8 mt-1 space-y-1">
          {SALES_DEPARTMENT_TOOL_MENU_ITEMS.map((item) => (
            <button
              key={item.key}
              onClick={() => handleSelectTool(item.key)}
              className={`w-full px-4 py-2 text-left text-sm transition-colors ${
                activeMenuItem === item.key ? 'bg-indigo-50 text-indigo-600 border-l-2 border-indigo-400' : 'text-gray-600 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-black'
              }`}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
